module.exports = __webpack_public_path__ + "static/media/techfrenetic-logo.3455aea8.svg";